// extracted by mini-css-extract-plugin
export default {"main":"Loading_main__l2nlc","loader":"Loading_loader__rS1ky","rotation":"Loading_rotation__BhLSQ"};